module.exports = __webpack_public_path__ + "img/mb-nav-bg-left.7aac33e.webp";